import axios from "axios";
import toast from "react-hot-toast";
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const viewRefundsList = (refundData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET_WALLET_REFUND_LIST_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/wallet-refund/list`,
        refundData,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "GET_WALLET_REFUND_LIST_SUCCESS", payload: data });
      } else {
        dispatch({ type: "GET_WALLET_REFUND_LIST_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "GET_WALLET_REFUND_LIST_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const viewRefund = (refundData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });

    try {
      dispatch({ type: "GET_WALLET_REFUND_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.get(
        `${BASE_URL}/wallet-refund/view/${refundData}`,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "GET_WALLET_REFUND_SUCCESS", payload: data });
      } else {
        dispatch({ type: "GET_WALLET_REFUND_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "GET_WALLET_REFUND_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const changeRefundStatus = (refundData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });

    try {
      dispatch({ type: "UPDATE_WALLET_REFUND_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/wallet-refund/change-status`,
        refundData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "UPDATE_WALLET_REFUND_SUCCESS", payload: data });
        toast.success("Status Changed Successfully!!");
        return data;
      } else {
        dispatch({ type: "UPDATE_WALLET_REFUND_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "UPDATE_WALLET_REFUND_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};
